import { Button, CardHeader, List, ListItem, ListItemText } from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import api from '../services/api';
import { t } from 'i18next';
import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import BrainoSnackbar from '../commons/BrainoSnackbar';
import I18n from '../commons/Utils';
import DialogHelp from '../elements/DialogHelp';
import DialogUpgrade from '../elements/DialogUpgrade';
import SkeletonList from '../elements/SkeletonListAvatar';

function withParams(Component) {
  return props => <Component {...props} params={useParams()} navigate={useNavigate()} />;
}

class ProfileDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      helpOpen: false,
      upgradeOpen: false,
      detailsOpen: false,
      helpTitle: '',
      helpText: '',
      helpTitle: <I18n prefix={this.props.prefix} type="title"></I18n>,
      helpText: <I18n prefix={this.props.prefix} type="help"></I18n>,
      upgradeTitle: t("edit_profile_new"),
      upgradeText: t("edit_profile_deny_text"),
      lang: localStorage.getItem('LANG'),
      snackOpen: false,
      snackMessage: '',
    }
  }

  closeDetailsDialog() {
    this.setState({ detailsOpen: false })
  }

  openDetailsDialog() {
    this.setState({ detailsOpen: true })
  }

  closeUpgradeDialog() {
    this.setState({ upgradeOpen: false })
  }

  openUpgradeDialog() {
    this.setState({ upgradeOpen: true })
  }

  async componentDidMount() {
    
    api.get('profiles/' + localStorage.getItem('ID'))
      .then(response => {
        const data = response.data
        this.setState({ data });
      }).catch(error => {
        console.log(error);
      })
  }

  resetProfile = () => {
    
    api.delete('questions/' + localStorage.getItem('ID'))
      .then(response => {
        const data = response.data
        this.setState({ snackOpen: true, snackMessage: "reset done" });
        localStorage.setItem("QST", 1)
        this.props.navigate("/profiling", { replace: true });
      }).catch((error) => {
        const httpCode = error.response.status
        if (httpCode === 401) {
          this.setState({ upgradeOpen: true })
        }
      }).finally(() => {
        this.setState({ snackOpen: false, snackMessage: "" });

      })
  }

  closeHelpDialog() {
    this.setState({ helpOpen: false })
  }

  openHelpDialog() {
    this.setState({ helpOpen: true })
  }

  render() {
    const { data, snackOpen, snackMessage } = this.state;
    return (
      <Card variant="outlined">
        <BrainoSnackbar
          open={snackOpen}
          onClose={() => { this.setState({ snackOpen: false }) }}
          message={snackMessage}
        />
        <DialogHelp
          closeHelpDialog={() => this.closeHelpDialog()}
          isHelpDialogOpen={this.state.helpOpen}
          helpDialogTitle={this.state.helpTitle}
          helpDialogContent={this.state.helpText}
          okButton="ok" />

        <DialogUpgrade
          closeUpgradeDialog={() => this.closeUpgradeDialog()}
          isUpgradeDialogOpen={this.state.upgradeOpen}
          upgradeDialogTitle={this.state.upgradeTitle}
          upgradeDialogContent={this.state.upgradeText}
        />

        <CardHeader
          title={<Typography gutterBottom variant="overline" component="h2"><Trans>profile_type</Trans></Typography>}
        ></CardHeader>
        <CardContent>
          {data ? (
            <List>
              <ListItem>
                <ListItemText primary={t("a_riskTitle")} secondary={<Trans>{data.risk}</Trans>} />
              </ListItem>
              <ListItem>
                <ListItemText primary={t("a_horTitle")} secondary={<Trans>{data.horizon}</Trans>} />
              </ListItem>
              <ListItem>
                <ListItemText primary={t("a_marketsTitle")} secondary={data.markets} />
              </ListItem>
              <ListItem>
                <ListItemText primary={t("a_sectorsTitle")} secondary={data.sectors} />
              </ListItem>
            </List>
          ) :
            <SkeletonList></SkeletonList>
          }
        </CardContent>
        <CardActions>
          <Button variant='contained' onClick={this.resetProfile} color="primary" ><Trans>edit_profile_button</Trans></Button>
        </CardActions>
      </Card>
    );
  }
}

export default withParams(ProfileDetails);
